import Big from "big.js";

Big.prototype.floor = function () {
    return this.round(0, Big.roundDown);
};

Big.prototype.ceil = function () {
    return this.round(0, Big.roundUp);
};

export { Big };
